import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { useThemeChange } from "../../../../utils/themeChange";
import { useApi } from "../../../../hooks/api/useApi";

import { ART } from "../../../../constants/api-constants";
import ListArt from "../list";
import { Link } from "react-router-dom";

const INITIAL_ART_LIMIT = 20;
const { LIST_ARTS } = ART;

const ExploreArt = () => {
  const themeChange = useThemeChange();
  const { getAll } = useApi();
  const [artLimit, setArtLimit] = useState(INITIAL_ART_LIMIT);
  const [searchText, setSearchText] = useState("");

  const arts = useQuery({
    queryKey: ["arts", artLimit, searchText],
    queryFn: () => getAll(LIST_ARTS, { name: searchText, limit: artLimit }),
  });

  const handleMore = () => {
    setArtLimit(artLimit + INITIAL_ART_LIMIT);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setSearchText(e.target.value);
  };

  const handleContactUs = () => {
    const receiver = "paul@artswap.com";
    const composeUrl = `https://mail.google.com/mail/u/0/?view=cm&to=${encodeURIComponent(
      receiver
    )}`;
    window.open(composeUrl, "_blank");
  };

  return (
    <div className={themeChange.add("section")}>
      <section className="jumbotron breadcumb no-bg">
        <div className="mainbreadcumb">
          <div className="container">
            <div className="row m-10-hor">
              <div className="col-12">
                <h1 className="text-center">Explore Licensing Opportunities</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="items_filter">
              <div
                className="row form-dark"
                id="form_quick_search"
                name="form_quick_search"
              >
                <div className="col">
                  <input
                    className="form-control"
                    id="search"
                    name="search"
                    onChange={onSearch}
                    placeholder="Search available license categories"
                    type="text"
                  />
                  <button id="btn-submit">
                    <i className="fa fa-search bg-color-secondary"></i>
                  </button>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ListArt arts={arts?.data} loading={arts?.isLoading} />
        {artLimit <= arts?.data?.length && (
          <div className="d-flex justify-content-center">
            <span className="btn-main lead" onClick={handleMore}>
              Load More
            </span>
          </div>
        )}
      </section>
      <div className="d-flex justify-content-center">
        <p className="mb-1">
          Please <Link onClick={handleContactUs}>contact us</Link> for any
          specific licensing needs
        </p>
      </div>
    </div>
  );
};

export default ExploreArt;
